<template>
  <div class="role-power-container custom-success-input">
    <div class="role-power-body">
      <div class="content">
        <div class="left">
          <div class="title">
            <el-row>
              <el-col class="role-list-title" :span="12">
                <h3>群组列表</h3>
              </el-col>
              <el-col class="text-right" :span="12">
                <el-tooltip class="item" effect="dark" content="新建群组" placement="bottom" popper-class="el-icon-plus-tooltip">
                  <i class="el-icon-plus" @click="newCreateRole"></i>
                </el-tooltip>
              </el-col>
            </el-row>
          </div>
          <div class="role-list-search">
            <el-input placeholder="请输入群组名称/成员" :value="roleListSearchKey" @input="roleListSearch" clearable>
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
          <div class="role-list">
            <ul>
              <vue-draggable v-model="roleList" @update="updateRoleSort" :disabled="isSaveRoleSort">
                <li v-for="(item, index) in roleList" :key="item.id">
                  <el-popover
                    placement="bottom-start"
                    width="200"
                    trigger="hover"
                    :content="item.comment">
                    <i slot="reference" v-show="item.comment !== '' && item.comment !== undefined" class="el-icon-info"></i>
                  </el-popover>
                  <div :class="{'item': true, 'active-role': item.id === selectPowerId}" @click="getRoleInfo(index, item)">
                    <el-row>
                      <el-col :span="18">
                        <el-input :class="['role-name']"
                                  v-focus="item.id !== currentEditRoleId"
                                  :disabled="item.id !== currentEditRoleId"
                                  :value="item.name"
                                  :title="item.name"
                                  @input="val => editRoleName(val, item.id)"
                                  @keydown.enter.native="$event.target.blur"
                                  @blur="saveRoleName($event, {name: item.name, id: item.id, sort: item.sort})"></el-input>
                      </el-col>
                      <el-col class="text-right role-list-operation" :span="6" v-show="item.id !== 'new_id'">
                        <el-button class="el-icon-edit" type="text" @click="editRole(item)"></el-button>
                        <el-button class="el-icon-delete" type="text" @click="deleteRole($event, item)"></el-button>
                      </el-col>
                    </el-row>
                  </div>
                </li>
              </vue-draggable>
              <div v-if="roleList.length === 0" class="item none-role">
                <p>暂无群组</p>
              </div>
            </ul>
          </div>
        </div>
        <div class="right">
          <!-- 当前群组-->
          <div class="select-power">当前群组：<span>{{selectPowerName}}</span></div>
          <!-- 权限栏-->
          <div class="power-list">
            <power-list-tree ref="powerListTree"
                             :powersListObj="powersListObj"
                             :checkedList="checkedList"
                             :loadingPowerLists="loadingPowerLists"
                             :isAdmin="isAdmin"
                             :noGroup="selectPowerId === ''"
                             @setCurrentSelect="setCurrentSelect">
              <div class="home-page" slot="homePage" v-loading="loadingPowerLists"
                   element-loading-text="加载中..."
                   element-loading-spinner="el-icon-loading">
                <el-checkbox v-model="homePagePower" @change="(val) => setHomePagePower(val, 'checked')">首页</el-checkbox>
                <label class="home-page-label">群组主页</label>
                <el-select v-model="home" clearable placeholder="请选择" filterable @change="setHomePagePower">
                  <el-option
                    v-for="(item, index) in menuList"
                    :key="item.id + index"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </power-list-tree>
            <div class="power-list-save-btn">
              <el-button type="primary" @click="savePower" :loading="savePowerLoading">保存</el-button>
            </div>
          </div>
          <div class="member-list">
            <!-- 搜索栏-->
            <div class="right-search-row">
              <el-input placeholder="请输入群组成员/类型/所属部门" :value="formData.searchForm.name" clearable @input="searchRoleMember">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
              <div class="right-search-button-div">
                <el-button class="right-search-button" @click="addMember">添加成员</el-button>
              </div>
            </div>
            <!-- 权限列表-->
            <div class="roleMember-table">
              <el-table height="100%" :data="tableData.roleMembertData" v-loading="isSearhing">
                <template slot="empty">
                  <div class="roleMember-table-empty">
                    <img src="../assets/table-empty.png"/>
                    <p>点击右上角添加群组成员</p>
                  </div>
                </template>
                <el-table-column
                  v-for="column in tableData.roleMemberColumnData"
                  :prop="column.prop"
                  :key="column.id"
                  :label="column.label"
                  :resizable="column.resizable"
                  :show-overflow-tooltip="true"
                  :align="column.align"
                  min-width="100"
                  v-cloak
                ></el-table-column>
                <el-table-column width="100" align="center" label="操作">
                  <template slot-scope="scope">
                    <el-button class="roleMember-table-button" type="text" @click="deleteRoleMemberColumn(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="roleMember-paging">
              <el-pagination
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="parseInt(paging.roleMember.totalNum)"
                :page-sizes="[10, 20, 30, 50, 100]"
                @size-change="roleMemberSizeChange"
                @current-change="roleMemberCurrentChange"
              ></el-pagination>
            </div>
          </div>
        </div>
        <div class="add-member-dialog custom-dialog-tree">
          <el-dialog
            title="添加成员"
            :visible.sync="dialogParams.treeDialogVisible"
            :close-on-click-modal="false"
            center
            top="10vh"
            :width="dialogParams.dialogWidth"
            @close="closeTreeDialog"
          >
            <div class="dialog-content">
              <el-tabs v-model="dialogParams.activeTabName" @tab-click="handleTabChange">
                <el-tab-pane label="人员/部门" name="people&department">
                  <div class="people-department-content">
                    <div class="pd-content">
                      <div class="pd-content-left custom-tree">
                        <div class="pd-content-left-search">
                          <el-input placeholder="搜索部门 / 人员" v-focus prefix-icon="el-icon-search" v-model="filterText"></el-input>
                        </div>
                        <el-tree
                          :data="nodeList"
                          show-checkbox
                          node-key="id"
                          ref="dialogTree"
                          :filter-node-method="filterNode"
                          empty-text=""
                          :check-strictly="true"
                          :props="defaultProps"
                          @check-change="dialogNodeClick">
                          <span slot-scope="{ node, data }">
                            <i :class="[data.type === 'user' ? 'el-icon-user' : 'el-icon-folder']"></i>
                            {{node.label}}
                          </span>
                        </el-tree>
                      </div>
                      <div class="pd-content-right">
                        <div class="pd-content-title">
                          <h4>已选择</h4>
                        </div>
                        <div class="show-select-label">
                          <template v-for="item in pdSelected">
                            <p :key="item.id"><i :class="[item.groupType === '人员' ? 'el-icon-user' : 'el-icon-folder']"></i>{{ item.name }}<i @click="deleteRoleMember(item)" class="el-icon-error"></i></p>
                          </template>
                        </div>
                      </div>
                    </div>
                    <div slot="footer" class="dialog-footer">
                      <div class="dialog-operation">
                        <div class="btn">
                          <el-button @click="cancelAddMember">取消</el-button>
                          <el-button type="primary" @click="saveSelectedMember" :loading="isSaveMember">保存</el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="岗位" name="post">
                  <div class="post-content">
                    <el-form
                      :inline="true"
                      :model="formData.addPostFormData"
                      @submit.native.prevent
                    >
                      <el-form-item label="关键字">
                        <el-input placeholder="请输入名称/部门" v-model="formData.addPostFormData.name"></el-input>
                      </el-form-item>
                      <el-form-item label="所属分类">
                        <el-select v-model="formData.addPostFormData.category" placeholder="请选择所属分类">
                          <el-option
                            v-for="item in postClissifyList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item>
                        <el-button class="add-post-search change-border-color" @click="searchAddPostList">查询</el-button>
                      </el-form-item>
                    </el-form>
                    <div class="add-post-table">
                      <el-table
                        v-loading="formData.addPostFormData.isLoadPosts"
                        height="400"
                        :data="tableData.addPostData"
                        ref="postTable"
                        row-key="id"
                        @selection-change="handleSelectionChange"
                        @row-click="handleRowClick"
                      >
                        <el-table-column type="selection" reserve-selection min-width="100" align="center" :resizable="false"></el-table-column>
                        <el-table-column
                          v-for="column in tableData.addPostColumnData"
                          :prop="column.prop"
                          :key="column.prop"
                          :label="column.label"
                          :resizable="column.resizable"
                          :show-overflow-tooltip="true"
                          :align="column.align"
                          min-width="100"
                          v-cloak
                        ></el-table-column>
                      </el-table>
                    </div>
                    <div class="add-post-paging text-right">
                      <el-pagination
                        background
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="parseInt(paging.addPost.totalNum)"
                        :page-sizes="[10, 20, 30, 50, 100]"
                        :pager-count="5"
                        @size-change="addPostSizeChange"
                        @current-change="addPostCurrentChange"
                        :current-page="paging.addPost.index"
                      ></el-pagination>
                    </div>
                    <div slot="footer" class="dialog-footer">
                      <div class="add-post-footer">
                        <el-button @click="cancelAddPost">取消</el-button>
                        <el-button type="primary" @click="addPostList" :loading="isSaveMember">保存</el-button>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-dialog>
        </div>
        <el-dialog
          class="permission-blacklist-dialog-relieve"
          :visible.sync="editRoleDialogVisible"
          title="编辑群组"
          width="30%"
          center
          @close="closeAddRoleComment"
          :close-on-click-modal="false"
          :close-on-press-escape="false">
          <el-form ref="RoleFormRef" label-position="left" :model="RoleForm" label-width="60px">
            <el-form-item label="群组名" prop="name" :rules="[{ required: true, message: '这是必填项', trigger: 'blur' }]">
              <el-input v-focus v-model="RoleForm.name" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input type="textarea" v-model="RoleForm.comment"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="editRoleDialogSave" type="primary" :loading="editRoleLoading">保存</el-button>
            <el-button @click="editRoleDialogVisible = false;RoleForm.name = '';RoleForm.comment = '';RoleForm.roleId = ''">取消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import powerListTree from '../power-list-tree'
import { rolePowerMixin } from './usersMixin'
import VueDraggable from 'vuedraggable'

const roleMemberColumnData = [
  {
    prop: 'name',
    label: '群组成员',
    resizable: false,
    align: 'center'
  },
  {
    prop: 'groupType',
    label: '类型',
    resizable: false,
    align: 'center'
  },
  {
    prop: 'belongDeptName',
    label: '所属部门',
    resizable: false,
    align: 'center'
  }
]
const addPostColumnData = [
  {
    prop: 'name',
    label: '岗位名称',
    resizable: false,
    align: 'center'
  },
  {
    prop: 'departmentName',
    label: '所属部门',
    resizable: false,
    align: 'center'
  },
  {
    prop: 'categoryName',
    label: '所属分类',
    resizable: false,
    align: 'center'
  }
]
export default {
  name: 'rolePower',
  components: {
    powerListTree,
    VueDraggable
  },
  mixins: [rolePowerMixin],
  data () {
    return {
      // 群组列表
      roleList: [],
      dialogParams: {
        dialogWidth: '37%',
        treeDialogVisible: false,
        type: '',
        activeTabName: 'people&department'
      },
      formData: {
        searchForm: {
          name: ''
        },
        addPostFormData: {
          isLoadPosts: false,
          name: '',
          category: ''
        }
      },
      // 群组查询关键字
      roleListSearchKey: '',
      tableData: {
        roleMembertData: [],
        roleMemberColumnData,
        addPostData: [],
        addPostColumnData
      },
      paging: {
        roleMember: {
          totalNum: 0,
          index: 1,
          size: 10
        },
        addPost: {
          totalNum: 0,
          index: 1,
          size: 10
        }
      },
      postClissifyList: [],
      nodeList: [],
      defaultProps: {
        children: 'children',
        label: 'name',
        disabled: this.disableAlreadySelect
      },
      checkPost: [],
      filterText: '',
      pdSelectedId: [],
      // 选择的人员
      peopleSelected: [],
      // 选择的部门
      departmentSelected: [],
      // 要删除掉的人员
      deleteMemberIds: [],
      // 要删除掉的部门
      deleteDepartmentIds: [],
      // 编辑群组列表的时候保存id
      roleId: '',
      // 选中的群组id 和 群组名
      selectPowerId: '',
      selectPowerName: '',
      // 用户名
      userName: '',
      tenantId: '',
      isSearhing: false,
      savePowerLoading: false,
      // 当前正在编辑群组名的群组id， 新建时为空
      currentEditRoleId: '',
      isSaveRoleName: false,
      isSaveRoleSort: false,
      isSaveMember: false,
      oldRoleName: '',
      oldRoleComment: '',
      editRoleDialogVisible: false,
      editRoleLoading: false,
      RoleForm: {
        name: '',
        comment: '',
        roleId: ''
      }, // 群组编辑弹窗
      roleCommentId: '' // 群组备注的显示id
    }
  },
  computed: {
    isAdmin () {
      return this.userName === 'admin' + this.tenantId
    },
    pdSelected () {
      return this.$_.concat(this.departmentSelected, this.peopleSelected)
    }
  },
  directives: {
    // 自动聚焦, 群组名编辑时，聚焦到未被禁用的input
    focus: {
      inserted (el, binding) {
        if (binding.value) {
          return null
        }
        setTimeout(() => el.querySelector('input').focus(), 20)
      },
      update (el, binding) {
        if (binding.value) {
          return null
        }
        setTimeout(() => el.querySelector('input').focus(), 20)
      }
    }
  },
  methods: {
    disableAlreadySelect (data, node) {
      return this.pdSelectedId.includes(data.id)
    },
    updateRoleSort () {
      // 每次拖动之后排序一下
      this.isSaveRoleSort = true
      this.roleList.forEach((role, index) => {
        role.sort = 100 + this.roleList.length - index
      })
      this.$axios.post('/auth-api/roles/sort', this.roleList).then(res => {
        this.isSaveRoleSort = false
        // todo: 更新当前选中群组索引
      }).catch(() => {
        this.isSaveRoleSort = false
      })
    },
    getRoleInfo (i, role) {
      // 新建还没生成群组id的时候 || 没改变的时候 不去重新请求权限数据
      if (!role.id || role.id === 'new_id' || this.selectPowerId === role.id) {
        return null
      }
      this.selectPowerId = role.id
      this.selectPowerName = role.name
      this.paging.roleMember.index = 1
      this.getRoleMemberList()
      // 切换群组后只展开菜单项清空所有选项
      this.resetRoleList()
      this.$refs.powerListTree.filterText = ''
      this.getAllMenusAndPowers()
    },
    // 新建群组
    newCreateRole () {
      // 如果当前正在编辑或者保存，不再新增
      if (this.isSaveRoleName || this.currentEditRoleId) {
        return null
      }
      this.oldRoleName = ''
      this.roleList.unshift({name: '', id: 'new_id'})
      this.currentEditRoleId = 'new_id'
    },
    // 编辑群组名
    editRoleName (val, id) {
      let index = this.roleList.findIndex(e => e.id === id)
      this.roleList[index].name = val
    },
    // 群组名失焦时的保存处理
    saveRoleName (e, {name, id, sort}) {
      // 如果是新建的，则直接删除；否则提示必填
      let index = this.roleList.findIndex(e => e.id === id)
      if (name === '' || name === undefined) {
        // 新建的则直接删掉
        if (id === 'new_id') {
          index !== -1 && this.roleList.splice(index, 1)
          this.currentEditRoleId = ''
        } else {
          e.preventDefault()
          e.target.focus()
          // 老的则提示必填
          return this.$message.error('请输入群组名')
        }
      } else {
        // 如果名字未修改不执行任何操作
        if (this.oldRoleName === name) {
          this.oldRoleName = ''
          this.currentEditRoleId = ''
          return null
        }
        this.isSaveRoleName = true
        // 如果是新建，sort比最上面的一个大1，否则保持原来的
        if (!sort && id === 'new_id') {
          // 第一个群组，sort默认是100
          if (this.roleList.length >= 2) {
            sort = Number(this.roleList[1].sort) + 1
          } else {
            sort = 100
          }
        }
        let params = {
          name: name,
          state: 1,
          sort: sort
        }
        if (this.roleId !== '') {
          params.id = this.roleId
        }
        // 群组备注
        if (this.RoleForm.comment) {
          params.comment = this.RoleForm.comment
        }
        this.$axios.post('/auth-api/roles', params).then(async res => {
          this.currentEditRoleId = ''
          this.roleId = ''
          let type = id === 'new_id' ? 'addRole' : ''
          this.resetRoleList()
          await this.getRoleList(type)
          // 编辑的时候当前选中的群组名也需要更新
          if (type !== 'addRole') {
            this.selectPowerName = name
          }
          this.$refs.powerListTree.filterText = ''
          this.getAllMenusAndPowers()
          this.isSaveRoleName = false
          this.editRoleLoading = false
          this.editRoleDialogVisible = false
          if (this.RoleForm.roleId !== '') {
            this.$message.success('修改成功')
          }
          this.oldRoleName = this.oldRoleComment = this.RoleForm.name = this.RoleForm.comment = this.RoleForm.roleId = ''
        }).catch(() => {
          this.currentEditRoleId = ''
          this.isSaveRoleName = false
          this.editRoleLoading = false
          this.editRoleDialogVisible = false
          this.oldRoleName = this.oldRoleComment = this.RoleForm.name = this.RoleForm.comment = this.RoleForm.roleId = ''
        })
      }
    },
    roleListSearch (val) {
      this.roleListSearchKey = val
      this.$axios.get(`/auth-api/roles?name=${val}`).then(res => {
        this.roleList = res.data || []
        if (res.data.length) {
          this.selectPowerId = res.data[0].id
          this.selectPowerName = res.data[0].name
          this.getRoleMemberList()
          // 默认获取菜单的权限列表
          this.getAllMenusAndPowers()
        } else if (res.data.length === 0) {
          this.powersListObj = {
            menu: [],
            process: [],
            app: [],
            other: [],
            system: []
          }
          this.tableData.roleMembertData = []
          return null
        }
      })
    },
    // 编辑
    editRole (item) {
      this.roleId = item.id
      // this.currentEditRoleId = item.id
      this.oldRoleName = item.name
      this.RoleForm.name = item.name
      this.RoleForm.comment = item.comment
      this.oldRoleComment = item.comment
      this.RoleForm.roleId = item.id
      this.editRoleDialogVisible = true
      this.$refs.RoleFormRef && this.$refs.RoleFormRef.clearValidate()
    },
    // 编辑群组
    editRoleDialogSave () {
      this.editRoleLoading = true
      this.$refs['RoleFormRef'].validate((valid) => {
        if (valid) {
          if (this.oldRoleName === this.RoleForm.name && this.oldRoleComment === this.RoleForm.comment) {
            this.editRoleLoading = false
            this.editRoleDialogVisible = false
            return true
          }
          if (this.oldRoleName === this.RoleForm.name) {
            this.oldRoleName = ''
          }
          let index = this.roleList.findIndex(e => e.id === this.RoleForm.roleId)
          this.saveRoleName('', {name: this.RoleForm.name, id: this.RoleForm.roleId, sort: this.roleList[index].sort})
        } else {
          this.editRoleLoading = false
          console.log('error submit!!')
          return false
        }
      })
    },
    // 删除
    deleteRole (e, row) {
      e.stopPropagation()
      this.$confirm('确认删除？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'deleMessageBoxcustom',
        center: true
      }).then(() => {
        this.selectPowerId = ''
        this.$axios.delete(`/auth-api/roles/${row.id}`).then(async () => {
          this.resetRoleList()
          this.$refs.powerListTree.filterText = ''
          await this.getRoleList()
          // 删除之后如果还有群组才去请求
          if (this.selectPowerId !== '') {
            this.getAllMenusAndPowers()
          }
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        })
      })
        .catch(() => {})
    },
    // 获取群组成员, 用户权限等...
    getRoleList (type) {
      return this.$axios.get(`/auth-api/roles?name=${this.roleListSearchKey}`).then(res => {
        this.roleList = res.data || []
        if ((!this.selectPowerId && res.data.length) || type === 'addRole') {
          this.selectPowerId = res.data[0].id
          this.selectPowerName = res.data[0].name
        } else if (res.data.length === 0) {
          this.selectPowerName = ''
          this.paging.roleMember.totalNum = 0
          this.tableData.roleMembertData = []
          return null
        }
        this.$nextTick(() => {
          this.getRoleMemberList()
        })
      })
    },
    addPostHandleClose (done) {
      done()
    },
    // 删除群组下的人员部门
    deleteRoleMember (member) {
      // 从左侧节点列表点过来点时候，node.id实际上就是 memberId, 但是往要添加点数组里赛点时候是直接放入里整个节点，所以会不存在memberId
      if (member.groupType === '部门') {
        this.deleteDepartmentIds.push(member.memberId ? member.memberId : member.id)
      } else if (member.groupType === '人员') {
        this.deleteMemberIds.push(member.memberId ? member.memberId : member.id)
      }
      // 把他从已选择id列表中删掉
      this.deleteInpdSelectedId(member)
      // 从左侧列表中新加入的是没有memberId的，但是打开弹窗重新加载就会有，刚打开弹窗时右侧列表的memberId === 左侧列表的id
      if (member.groupType === '部门') {
        let index = this.departmentSelected.findIndex(m => m.memberId === member.memberId || m.memberId === member.id || m.id === member.id)
        this.departmentSelected.splice(index, 1)
      } else if (member.groupType === '人员') {
        let index = this.peopleSelected.findIndex(m => m.memberId === member.memberId || m.memberId === member.id || m.id === member.id)
        this.peopleSelected.splice(index, 1)
      }
      // 如果当前是选中状态，则取消其选中状态
      let currentCheckedKeys = this.$refs.dialogTree.getCheckedKeys()
      if (currentCheckedKeys.includes(member.memberId ? member.memberId : member.id)) {
        this.$refs.dialogTree.setCheckedNodes(currentCheckedKeys.filter(id => id !== member.memberId && id !== member.id))
      }
    },
    // 删除群组下的成员
    deleteRoleMemberColumn (row) {
      this.$confirm('确认删除？', '', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        customClass: 'deleMessageBoxcustom',
        center: true
      }).then(() => {
        this.$axios
          .delete(
            `/auth-api/roles/deleteRoleMember/?roleId=${
              this.selectPowerId
            }&memberId=${row.memberId}&memberName=${row.name}&memberType=${row.groupType}`
          )
          .then(() => {
            this.getRoleMemberList()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          })
      })
        .catch(() => {})
    },
    roleMemberSizeChange (val) {
      this.paging.roleMember.size = val
      this.paging.roleMember.index = 1
      this.$nextTick(() => {
        this.getRoleMemberList()
      })
    },
    roleMemberCurrentChange (val) {
      this.paging.roleMember.index = val
      this.$nextTick(() => {
        this.getRoleMemberList()
      })
    },
    searchRoleMember (val) {
      this.formData.searchForm.name = val
      this.paging.roleMember.index = 1
      this.$nextTick(() => {
        this.getRoleMemberList()
      })
    },
    addPostSizeChange (val) {
      this.paging.addPost.index = 1
      this.paging.addPost.size = val
      this.$nextTick(() => {
        this.getPostList()
      })
    },
    addPostCurrentChange (val) {
      this.paging.addPost.index = val
      this.$nextTick(() => {
        this.getPostList()
      })
    },
    handleSelectionChange (val) {
      this.checkPost = val
    },
    handleRowClick (row, column, event) {
      this.$refs.postTable.toggleRowSelection(row)
    },
    filterNode (val, data) {
      if (!val) return true
      return data.name && data.name.indexOf(val) !== -1
    },
    // 把他从已选择id列表中删掉
    deleteInpdSelectedId (member) {
      let index = this.pdSelectedId.findIndex(e => e === member.id || e === member.memberId)
      if (index !== -1) {
        this.pdSelectedId.splice(index, 1)
      }
    },
    // 点击的时候添加数据
    dialogNodeClick (node, state) {
      // 不需要子节点数据
      delete node.children
      if (node.type === 'department') {
        node.groupType = '部门'
        // 如果是勾选
        if (state) {
          this.departmentSelected.push(node)
          // 如果不存在已选择id列表中要放入
          if (!this.pdSelectedId.includes(node.id)) {
            this.pdSelectedId.push(node.id)
          }
          // 如果存在于[部门]待删id除列表中，则需要从[部门]待删除列表中去掉
          let index = this.deleteDepartmentIds.findIndex(e => e === node.id)
          if (index !== -1) {
            this.deleteDepartmentIds.splice(index, 1)
          }
        } else {
          let index = this.departmentSelected.findIndex(m => m.memberId ? m.memberId === node.id : m.id === node.id)
          this.departmentSelected.splice(index, 1)
          this.deleteInpdSelectedId(node)
        }
      } else if (node.type === 'user') {
        node.groupType = '人员'
        if (state) {
          this.peopleSelected.push(node)
          // 如果不存在已选择id列表中要放入
          if (!this.pdSelectedId.includes(node.id)) {
            this.pdSelectedId.push(node.id)
          }
          // 如果存在于[人员]待删id除列表中，则需要从[人员]待删除列表中去掉
          let index = this.deleteMemberIds.findIndex(e => e === node.id)
          if (index !== -1) {
            this.deleteMemberIds.splice(index, 1)
          }
        } else {
          let index = this.peopleSelected.findIndex(m => m.memberId ? m.memberId === node.id : m.id === node.id)
          this.peopleSelected.splice(index, 1)
          this.deleteInpdSelectedId(node)
        }
      }
    },

    addMember () {
      if (this.selectPowerId === '') {
        return this.$message.info('请先添加群组')
      }
      this.nodeList = []
      this.getPDSelected(this.selectPowerId)
      this.$nextTick(() => {
        this.dialogParams.treeDialogVisible = true
      })
    },
    searchPD () {
      this.$axios.get(`/auth-api/departments/roleMemberTree`)
        .then(res => {
          this.nodeList = res.data ? res.data : []
        })
    },
    // 去重
    distinct (array) {
      if (array && array.length) {
        let ary = []
        for (let i = 0; i < array.length; i++) {
          for (let j = i + 1; j < array.length; j++) {
            if (array[i] === array[j]) {
              j = i++
            }
          }
          ary.push(array[i])
        }
        return ary
      } else {
        return array
      }
    },
    setCurrentSelect (data) {
      // 按类型把所有当前选择的权限存在一个对象里,只有改变了的才需要保存去走接口
      let currentType = data.type
      let checkedList = {}
      // 去重后分类
      if (currentType === 'APP_Other') {
        // 过滤掉手动添加的app这个最外层的id
        checkedList['app'] = this.distinct(data.checked.filter(e => e !== '1_43F47C-7940-0015-9F77-9965999EB4_G'))
        this.$set(this.checkedList, currentType, checkedList['app'])
        this.currentSelectPower['app'] = checkedList['app']
        !this.changedType.includes('app') && this.changedType.push('app')
      } else {
        checkedList[currentType] = this.distinct(data.checked)
        this.$set(this.checkedList, currentType, checkedList[currentType])
        this.currentSelectPower[currentType] = checkedList[currentType]
        !this.changedType.includes(currentType) && this.changedType.push(currentType)
      }
      // 已选择的菜单
      this.countChildrenChecked(this.powersListObj[currentType], currentType)
    },
    // 请求保存权限
    savePowerRequest (type, data) {
      let params = {
        roleId: this.selectPowerId,
        menuIds: {[type]: data}
      }
      return this.$axios.post(`/auth-api/roles/createRoleMenu`, params).then((res) => {
        this.$refs.powerListTree.isSelectingParent = false
      })
    },
    // 保存数据
    savePower () {
      // 如果还在加载中禁止保存
      if (this.loadingPowerLists) {
        return this.$message.warning('数据加载中, 请稍候')
      }
      // 需要请求保存权限的类型的数组
      let requsetArray = []
      this.changedType.forEach(key => {
        if (this.currentSelectPower[key]) {
          requsetArray.push(this.savePowerRequest(key, this.currentSelectPower[key]))
        }
      })
      if (requsetArray.length > 0) {
        this.savePowerLoading = true
        return Promise.all(requsetArray).then(() => {
          this.savePowerLoading = false
          this.changedType = []
          this.$refs.powerListTree.isSelectingParent = false
          this.$message.success('保存成功!')
        }).catch(() => {
          this.savePowerLoading = false
          this.$refs.powerListTree.isSelectingParent = false
        })
      } else {
        this.$message.success('保存成功!')
      }
    },
    // 获取已选择的数据
    getPDSelected (id) {
      this.peopleSelected = []
      this.departmentSelected = []
      this.pdSelectedId = []
      let getPeopleSelected = this.$axios.get(`/auth-api/roles/getRoleMemberByType?roleId=${id}&groupType=emp`)
      let getDepartMentSelected = this.$axios.get(`/auth-api/roles/getRoleMemberByType?roleId=${id}&groupType=dep`)
      return Promise.all([getPeopleSelected, getDepartMentSelected]).then(res => {
        this.peopleSelected = res[0].data ? res[0].data : []
        this.departmentSelected = res[1].data ? res[1].data : []
        this.$nextTick(() => {
          this.pdSelectedId = this.pdSelected.map(e => e.memberId)
        })
      })
    },
    // 添加成员弹窗切换tab
    handleTabChange (tab) {
      if (tab.name === 'post' && tab.active) {
        this.$refs.postTable.clearSelection()
        this.addPost()
      }
    },
    // 添加岗位
    addPost () {
      if (this.selectPowerId === '') {
        return this.$message.info('请先添加群组')
      }
      this.getPostList()
    },
    // 保存选中的节点
    saveSelectedMember () {
      let params = {
        roleId: this.selectPowerId,
        groupMemberIds: {
          '人员': [],
          '部门': []
        },
        deleteMemberIds: {}
      }
      if (this.$refs.dialogTree.getCheckedKeys().length > 0 || this.deleteMemberIds.length > 0 || this.deleteDepartmentIds.length) {
        this.isSaveMember = true
        // 添加的人员和部门
        this.departmentSelected.forEach(item => {
          if (!item.memberId) {
            params.groupMemberIds['部门'].push(item.id)
          } else {
            params.groupMemberIds['部门'].push(item.memberId)
          }
        })
        this.peopleSelected.forEach(item => {
          if (!item.memberId) {
            params.groupMemberIds['人员'].push(item.id)
          } else {
            params.groupMemberIds['人员'].push(item.memberId)
          }
        })
        // 删除的人员和部门
        if (this.deleteMemberIds.length || this.deleteDepartmentIds.length) {
          params.deleteMemberIds = {
            '人员': [],
            '部门': []
          }
        }
        this.deleteMemberIds.forEach(id => {
          params.deleteMemberIds['人员'].push(id)
        })
        this.deleteDepartmentIds.forEach(id => {
          params.deleteMemberIds['部门'].push(id)
        })
        this.$axios.post(`/auth-api/roles/addRoleMember`, params).then(res => {
          this.isSaveMember = false
          this.cancelAddMember()
        }).catch(() => {
          this.isSaveMember = false
        })
      } else {
        this.$message({
          message: '请选择一条以上的数据在保存',
          type: 'warning'
        })
      }
    },
    cancelAddMember () {
      this.dialogParams.treeDialogVisible = false
    },
    closeTreeDialog () {
      this.nodeList = []
      this.peopleSelected = []
      this.departmentSelected = []
      this.pdSelectedId = []
      this.deleteMemberIds = []
      this.deleteDepartmentIds = []
      this.dialogParams.activeTabName = 'people&department'
      this.getRoleList()
    },
    // 获取群组成员列表
    getRoleMemberList () {
      this.isSearhing = true
      let params = {
        index: this.paging.roleMember.index,
        size: this.paging.roleMember.size
      }
      params.filters = {
        name: this.formData.searchForm.name,
        roleId: this.selectPowerId
      }
      this.$axios
        .get('/auth-api/roles/getMemberByRoleId', {
          params
        })
        .then(res => {
          // 只有当前选择群组的数据返回来了才赋值
          if (res.data.roleId === this.selectPowerId) {
            this.paging.roleMember.totalNum = res.data.total || 0
            this.tableData.roleMembertData = res.data.items || []
          }
          this.isSearhing = false
        }).catch(() => {
          this.isSearhing = true
        })
    },
    // 获取岗位列表
    getPostList () {
      this.formData.addPostFormData.isLoadPosts = true
      this.tableData.addPostData = []
      let params = {
        index: this.paging.addPost.index,
        size: this.paging.addPost.size
      }
      params.filters = {
        name: this.formData.addPostFormData.name,
        categoryId: this.formData.addPostFormData.category
      }
      this.$nextTick(() => {
        this.$axios
          .get(`/auth-api/posts`, {
            params
          })
          .then(res => {
            this.formData.addPostFormData.isLoadPosts = false
            this.tableData.addPostData = res.data.items || []
            this.paging.addPost.totalNum = res.data.total
            this.getPostClissifyList()
          })
      })
    },
    // 查询岗位列表
    searchAddPostList () {
      this.formData.addPostFormData.name = this.formData.addPostFormData.name.replace(
        /(^\s*)|(\s*$)/g,
        ''
      )
      this.paging.addPost.index = 1
      this.$nextTick(() => {
        this.getPostList()
      })
    },
    // 保存岗位列表
    addPostList () {
      if (this.checkPost.length === 0) {
        return this.$message.error('请选择需要添加的岗位')
      }
      this.isSaveMember = true
      let params = {
        roleId: this.selectPowerId,
        groupMemberIds: {
          '岗位': []
        }
      }
      this.checkPost.forEach(item => {
        params.groupMemberIds['岗位'].push(item.id)
      })
      this.$axios.post(`/auth-api/roles/addRoleMember`, params).then(res => {
        this.cancelAddPost()
        this.getRoleMemberList()
        this.isSaveMember = false
      }).catch(() => {
        this.isSaveMember = false
      })
    },
    // 取消保存岗位
    cancelAddPost () {
      this.checkPost = []
      this.formData.addPostFormData.name = ''
      this.formData.addPostFormData.category = ''
      this.dialogParams.treeDialogVisible = false
    },
    // 获取所属分类
    getPostClissifyList () {
      this.$axios.get(`/auth-api/organization/getPostCategories`).then(res => {
        this.postClissifyList = res.data || []
      })
    },
    // 获取用户信息
    getUserInfo () {
      this.$axios.get('/auth-api/oauth/currentUserInfo').then(res => {
        // 通过 tenantId 加上 admin 来判断是否是admin账号
        this.userName = res.data.username
        this.tenantId = res.data.tenantId
      })
    },
    // 获取左侧人员
    getRoles () {
      return new Promise((resolve, reject) => {
        this.$axios.get('/auth-api/roles').then(res => {
          this.roleList = res.data || []
          if (!this.selectPowerId && res.data.length) {
            this.selectPowerId = res.data[0].id
            this.selectPowerName = res.data[0].name
          }
          this.$nextTick(() => {
            resolve(res.data)
          })
        })
      })
    },
    // 取消添加群组备注
    closeAddRoleComment () {
      this.RoleForm.name = this.RoleForm.comment = this.RoleForm.roleId = ''
    }
  },
  created () {
    this.getUserInfo()
    // 因不明原因导致获取的所有菜单传给子组件时为undefined
    this.getRoles().then(async data => {
      this.getRoleMemberList()
      if (data.length !== 0) {
        this.selectPowerId = data[0].id
        // 加载时获取所有数据,并默认展开菜单项
        this.getAllMenusAndPowers()
      } else {
        this.checkedList = {}
        this.loadingPowerLists = false
      }
    })
  },
  beforeDestroy () {
    this.selectPowerId = ''
  },
  watch: {
    filterText (val) {
      this.$refs.dialogTree && this.$refs.dialogTree.filter(val)
    },
    'dialogParams.treeDialogVisible' (val) {
      // 打开弹窗时请求所有部门数据
      if (val) {
        this.searchPD()
      }
      if (!val) {
        this.filterText = ''
      }
    },
    selectPowerId (val, oldVal) {
      // 当前未选中群组或改变群组的时候置空所有已选中权限和改变项
      if (!val || val !== oldVal) {
        this.changedType = []
        Object.keys(this.currentSelectPower).forEach(key => {
          this.currentSelectPower[key] = []
        })
      }
    }
  }
}
</script>

<style lang="scss">
  @import "@/assets/scss/common.scss";

  [v-cloak] {
    display: none;
  }

  .role-power-container {
    height: 100%;
    position: relative;

    div,
    span,
    p,
    label {
      font-size: 12px;
    }

    .role-power-body {
      height: 100%;
      padding: 10px;

      .content {
        height: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        -webkit-justify-content: space-between;
        justify-content: space-between;

        .text-right {
          text-align: right;
        }

        .left {
          background: #fff;
          box-shadow: 0px 3px 9px 0px rgba(179, 196, 208, 0.2);
          border-radius: 4px 0;
          height: 100%;
          padding-top: 13px;
          flex: 2;

          .title {
            padding: 0 10px 10px 0;

            h3 {
              border-left: 2px solid var(--primary, #62a8f2);
              padding-left: 12px;
              font-size: 14px;
              font-weight: 500;
              height: 100%;
            }

            .role-list-title {
              height: 28px;
              line-height: 28px;
            }
            .text-right .el-icon-plus{
              color: #C2C3C4;
              cursor: pointer;
              line-height: 28px;
              &:hover{
                color: var(--primary, #54ABF1);
              }
            }
          }
          .role-list-search{
            padding: 0 12px;
            margin: 15px 0 20px;
          }

          .role-list {
            height: calc(100% - 100px);
            overflow-y: auto;
            .el-icon-info {
              float: left;
              line-height: 40px;
              margin-left: 3px;
              color: #C2C3C4;
            }
            .el-icon-info:hover {
              color: var(--primary, #55ACF1);
            }
            .item {
              padding: 0 10px 0 24px;
              border-bottom: 1px solid #edf2f5;
              cursor: pointer;

              .role-list-operation {
                display: none;
              }

              &:not(.active-role):hover {
                background-color: var(--light-bg-1, #F4F8FB);
                .el-row .el-col .role-name.el-input{
                  input.el-input__inner{
                    background-color: var(--light-bg-1, #F4F8FB);
                  }
                }

                .role-list-operation {
                  display: block;
                }
              }

              .el-row {
                .el-col {
                  height: 39px;
                  line-height: 39px;

                  .el-icon-delete {
                    color: #bdccd9;
                    margin-left: 10px;
                  }
                  .el-icon-delete:hover{
                    color: #F56C6C;
                  }
                  .el-icon-delete:active{
                    color: #F33648;
                  }
                  .el-icon-edit{
                    color: #bdccd9;
                  }
                  .el-icon-edit:hover{
                    color: var(--primary, #54ABF1);
                  }
                  .el-icon-edit:active{
                    color: var(--shade-1, #3F91D3);
                  }

                  .role-name{
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    input{
                      border: none;
                      padding: 0;
                      width: 100%;
                      height: 100%;
                      color: #232323;
                    }
                    &.el-input.is-disabled{
                      input{
                        background-color: #FFFFFF;
                      }
                    }
                  }
                }
              }
            }
            .item.active-role {
              background-color: var(--light-9, #ecf5fb);
              border-left: 2px solid var(--primary, #4592E4);

              .el-row {
                .el-col .role-name.el-input {
                  input {
                    background-color: var(--light-9, #ecf5fb);
                  }
                }
                .role-list-operation {
                  display: block;
                }
              }
            }
            .none-role {
              text-align: center;
              border-bottom: 0;
              margin-right: 10px;
              margin-top: 20px;
              color: #c0c4cc;

              &:hover {
                background-color: #fff;
              }
            }
          }
        }

        .right {
          display: flex;
          background: #fff;
          box-shadow: 0px 3px 9px 0px rgba(179, 196, 208, 0.2);
          border-radius: 4px 0;
          height: 100%;
          flex: 9;
          margin-left: 15px;
          overflow: auto;
          padding: 10px;
          position: relative;
          .select-power{
            position: absolute;
            top: 20px;
            left: 22px;
            font-size: 14px;
            color: #232323;
            span{
              font-size: 16px;
              color: var(--primary, #54ABF1);
            }
          }
          .power-list{
            width: 25%;
            min-width: 260px;
            border-right: 1px solid #EDF2F5;
            padding: 0 12px;
            margin-top: 55px;
            overflow-x: scroll;
            .home-page{
              margin-top: 10px;
              margin-bottom: 10px;
              padding-left: 25px;
              .el-checkbox{
                display: block;
                margin-bottom: 10px;
                margin-left: -25px;
                padding-left: 10px;
                .el-checkbox__label{
                  color: #606266;
                }
                .el-checkbox__inner {
                  background-color: #ffffff;
                  &::after{
                    border: 1px solid #409EFF;
                    border-left: 0;
                    border-top: 0;
                  }
                }
              }
              .home-page-label{
                display: block;
                padding-left: 10px;
                margin: 0 10px 10px 0;
                color: #606266;
              }
            }
            .power-list-save-btn{
              text-align: center;
              .el-button{
                width: 72px;
                height: 25px;
                padding: 0;
              }
            }
          }
          .member-list{
            box-sizing: border-box;
            flex: 2 1 70%;
            margin-top: 55px;
            padding: 0 15px;
            .right-search-row{
              display: flex;
              justify-content: space-between;
              margin-bottom: 18px;
              box-sizing: border-box;
              white-space: nowrap;
              .el-input{
                margin-right: 20px;
              }
              .right-search-button-div{
                text-align: right;
                .right-search-button{
                  width: 60px;
                  height: 26px;
                  padding: 0;
                  color: var(--primary, #62A8F2);
                  border-color: var(--primary, #62A8F2);
                  &:hover{
                    background-color: var(--light-bg-1, #E4F1FF);
                  }
                  &:focus{
                    background-color: var(--light-9, #CDE3FA);
                  }
                }
              }
            }
          }
          .el-row .el-col{
            white-space: nowrap;
          }
          .roleMember-table {
            width: 100%;
            height: calc(100% - 100px);
            position: relative;
            .el-table{
              position: absolute;
            }
            .roleMember-table-button{
              color: #AFB3B6;
              &:hover{
                color: #F33648;
              }
            }
            .roleMember-table-empty{
              margin-top: -20px;
              img{
                width: 72px;
                height: 60px;
              }
              p{
                line-height: 30px;
                font-size: 12px;
                color:#232323;
              }
            }
          }

          .roleMember-paging {
            padding-top: 15px;
            text-align: right;
          }

        }

        @media screen and (max-width: 1400px) {
          .right {
            flex: 6;
          }

          .left {
            flex: 2;
          }
        }

        .add-member-dialog {
          .el-dialog{
            min-width: 510px;
          }
          .dialog-content {
            .el-tabs{
              width: 100%;
              .el-tabs__header{
                .el-tabs__nav-wrap{
                  &::after{
                    height: 0;
                  }
                  .el-tabs__nav{
                    .el-tabs__active-bar{
                      display: none;
                    }
                    .el-tabs__item{
                      &.is-top{
                        padding: 0 10px;
                      }
                      &.is-active{
                        border-bottom: 2px solid var(--primary, #4592E4);
                      }
                      &:not(:last-of-type){
                        position: relative;
                        &::after{
                          content: '';
                          height: 20px;
                          position: absolute;
                          width: 1px;
                          left: 68px;
                          top: 10px;
                          background: #EAEAEA;
                        }
                      }
                    }
                  }
                }
              }
              .people-department-content{
                .pd-content{
                  display: flex;
                  width: 100%;
                  height: 460px;
                  border: 1px solid #C2C3C4;
                  border-radius: 4px;
                  padding: 14px;
                  padding-right: 0;
                  .pd-content-left,.pd-content-right{
                    flex: 1 1 50%;
                  }
                  .pd-content-left{
                    border-right: 1px solid #C2C3C4;
                    .pd-content-left-search{
                      .el-input{
                        width: 95%;
                      }
                    }
                    .el-tree{
                      height: calc(100% - 30px);
                      overflow: scroll;
                    }
                  }
                  .pd-content-right{
                    .pd-content-title{
                      text-align: center;
                      h4{
                        line-height: 60px;
                        color: #232323;
                        font-weight: 400;
                      }
                    }
                    .show-select-label{
                      p{
                        margin: 5px 0;
                        padding: 0 10px 0 20px;
                        color: #2A2929;
                        line-height: 22px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        &:nth-of-type(even){
                          background: var(--light-9, #ECF5FB);
                        }
                        i{
                          color: #CBCBCB;
                          margin-right: 13px;
                        }
                        i.el-icon-error{
                          cursor: pointer;
                          float: right;
                          &:hover{
                            color: #FB9391;
                          }
                          &:active{
                            color: #EE5757;
                          }
                        }
                      }
                    }
                  }
                }
              }
              .post-content {
                .el-form .el-form-item{
                  .el-input input{
                    max-width: 155px;
                  }
                }
                .add-post-search {
                  margin: 0 10px;
                }

                .add-post-paging {
                  padding-top: 10px;
                  .el-pagination{
                    overflow-x: scroll;
                  }
                }

                .add-post-footer {
                  text-align: center;
                }
                .change-border-color {
                  border-color: var(--primary, #62A8F2);
                  color: var(--primary, #62A8F2);
                }
              }
            }
            .dialog-footer{
              padding-top: 7px;
            }
          }

          .custom-tree
          .is-current
          > .el-tree-node__content
          > .el-tree-node__label {
            color: #606266;
          }
        }

        .permission-blacklist-dialog-relieve {
          .el-dialog__body>.el-form>.el-form-item {
            input {
              color: #000;
            }
            textarea {
              resize: none;
              color: #000;
            }
          }
        }
      }
    }
    @keyframes fadein
    {
      from {
        opacity:0;
        transform: scale(0.3);
        -webkit-transform: scale(0.3);
      }
      to {
        opacity:1;
        transform: scale(1);
        -webkit-transform: scale(1);
      }
    }

    @-webkit-keyframes fadeout /*Safari and Chrome*/
    {
      from {opacity:0;}
      to {opacity:1;}
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/system/users/role-power.vue